import {IR23ReportMetadata} from "@/interfaces/report";

export const testReportMetadata: IR23ReportMetadata = {
  r23ReportId: 1,
  reportTitle: 'Test Report',
  ownerFirstName: 'R23OwnerFirstname',
  ownerLastName: 'R23OwnerLastname',
  ownerEmail: 'r23OwnerEmail@pavexpress.com',
  created: '2019-04-26T20:20:10Z',
  updated: '2019-06-25T15:20:00Z',
  conversion_complete: false,
  conversion_done_analyze:false,
  conversion_done_design:false,
  conversion_done_other:false,
  conversion_started:false,
  conversion_done_lcca:false,
  visible: true
};

